import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import * as CurrencyFormat from 'react-currency-format';
import '../css/SuperlifeLegacyPlan.css';
import Dropdown from 'react-dropdown';
import { Table } from 'react-bootstrap';

class Commissions extends Component {
    constructor(props) {
        super(props)


        this.state = {
            adviserSelected: null,
            advisers: [],
            commissions: []
        }
    }

    static getDerivedStateFromProps(props, state) {

        let advisers = [];
        let adviser1 = {}
        const adviserGroup = {
            label: "Adviser",
            value: -1
        }
        advisers.push(adviserGroup)
        
        const advisersForPeriod = [...new Set(props.commissions?.map(commissions => commissions.adviserName))];
        advisersForPeriod && advisersForPeriod.map((index,adviser) => {
            adviser1 = {
                label: adviser,
                value: index
            }
            advisers.push(adviser1)
        })
        if (!state.adviserSelected || (state.adviserSelected && state.adviserSelected.value === -1))
            return {
                commissions: props.commissions,
                advisers: advisers,
                adviserSelected: advisers[0]
            }
        else
            return {
                advisers: advisers,
            }
    }

    componentDidUpdate(prevProps, prevState) {
        const commissions = this._filterAdvisers(this.state.adviserSelected.label)
        if (this.state.adviserSelected && this.state.adviserSelected.value !== -1 && prevState.adviserSelected !== this.state.adviserSelected)
            this.setState({ commissions: commissions })
    }

    _onSelect(e) {
        this.setState({ adviserSelected: e });
    }

    _filterAdvisers(selectedAdviser) {
        const commissions = 
                selectedAdviser == 'All' ?
                    this.props.commissions :
                    this.props.commissions.filter(commission => commission.adviserName === selectedAdviser).map(commission => commission)
        return commissions
    }

    render() {
        //const advisers = this.advisers
        const { t } = this.props
        let advisers =  ["All"]
        const advisersForPeriod = [...new Set(this.props.commissions?.map(commissions => commissions.adviserName))];
        advisersForPeriod.map(adviser => advisers.push(adviser))
        
        //const commissions = this.props.commissions;
        return (
            //style={{marginLeft: "12px", marginRight: "12px"}}
            <div>
                {!this.props.groupLogin ? 'Adviser' : <table className="commissionHeader">
                <tr>
                        <td className='rightAligned'>{t('membersTable:adviser')}</td>
                        <td>
                            <div style={{float:"right", width:"100%"}}>
                                <Dropdown className="adviserFilter" controlClassName="dropdown-box-commissionDetails"
                                                menuClassName="dropdown-contents-commissionDetails"
                                                arrowClassName="dropdown-arrow-totalMembers"
                                                options={advisers} 
                                                onChange={e => this._onSelect(e)}
                                                value={this.state.adviserSelected}
                                                placeholder="Select an option" arrowOpen={true} />
                            </div>
                        </td>
                </tr>
                </table>
                }
                <Table responsive className="superlifeLegacyPlan commissionDetails" style={{ width: "100%", marginLeft: "0px" }}>
                    <thead>
                        <tr>
                            <th>{t('feeDetailsTable:group')}</th>
                            <th>{t('feeDetailsTable:from')}</th>
                            <th>{t('feeDetailsTable:to')}</th>
                            <th rowSpan="2">
                                {t('feeDetailsTable:adviser')}
                            </th>
                            <th>{t('feeDetailsTable:scheme')}</th>
                            <th>{t('feeDetailsTable:mbrorIrdNumber')}</th>
                            <th>{t('feeDetailsTable:memberName')}</th>
                            <th>{t('feeDetailsTable:amount')}</th>
                            <th>{t('feeDetailsTable:status')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            !this.state.commissions ? <tr>{t('fetching') + " " + t('commission')}s...</tr> :
                                this.state.commissions.map((commission, key) =>
                                    <tr key={key}>
                                        <td style={{ textAlign: "center" }}>{commission.groupName}</td>
                                        <td style={{ textAlign: "center" }}>{commission.startDate}</td>
                                        <td style={{ textAlign: "center" }}>{commission.endDate}</td>
                                        <td style={{ textAlign: "center" }}>{commission.adviserName}</td>
                                        <td style={{ textAlign: "center" }}>{commission.scheme}</td>
                                        <td style={{ textAlign: "center" }}>{commission.irdNumber}</td>
                                        <td style={{ textAlign: "left" }}>{commission.memberName}</td>
                                        <td><CurrencyFormat value={Number(commission.amount).toFixed(2)}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={'$'} /> </td>
                                        <td style={{ textAlign: "center" }}>{commission.status}</td>
                                    </tr>)
                        }
                    </tbody>
                </Table>
            </div>
        )
    }
}

export default withTranslation()(Commissions)